export default {
  companyInfo: 'Company Information',
  companyName: 'Company Name',
  legalPerson: 'Legal person/In Charge (company)',
  nameNoteAndCompanyName: 'Name Notes/Original company name',
  nickName: 'Nickname',
  nature: 'Category', // company/individual/studio/international school/other
  natureNote: 'Property Statement',
  location: 'Area',
  companyAddress: 'Company Address',
  parentName: 'Parent Company',
  taxCode: 'Tax ID/Unified Social Credit Code (company) ',
  isSettlementPort: 'Independent Settlement?',
  idCardNum: 'ID Card (individual/legal person) ',
  firstContractTime: 'First Contract date ',
  firstOfferItemTime: 'Creation Date ',
  remark: 'Remark',
  accountList: 'Account List',
  authorityQuery: 'Access Right',
  businessDataManagement: 'Business Data Management',
  subcompanyList: 'Subcompany List',
  roleType: 'Role Type',
  department: 'Department',
  administrator: 'Administrator',
  finance: 'Finance',
  subagentDataOpenSet: 'subagent data open set',
  bmsDataOpenSet: 'BMS Setting',
  businessSupervisor: 'Business Supervisor',
  viewSubordinate: 'View Subordinates',
  companyNumber: 'Number',
  legalPersonName: 'legal person name',
  largeArea: 'Large Area',
  area: 'Area',
  bindStudentNum: 'Number of bound students',
  addAccount: 'Add Account',
  editAccount: 'Edit Account',
  mobile: 'Mobile',
  mobileAreaCode: 'Mobile Area Code',
  telAreaCode: 'Tel Area Code',
  tel: 'Tel',
  // isCommissionEmail: 'Contact email for contract commission?',
  // isNewsEmail: 'Business news receive email?',
  isCommissionEmail: 'Receive contractual commission',
  isNewsEmail: 'Receive promotional emails',
  deleteContactConfirm: 'Are you sure you want to delete this account information?',
  account: 'Account',
  setBusinessSuperior: 'Set Business Supervisor',
  loginInfo: 'Login default Account Information ',
  defaultAccount: 'Account ',
  defaultPwd: 'Default Password ',
  messagingSoftware1: "Messaging App 1",
  messagingSoftware2: "Messaging App 2",
  accountFormMobileTips: 'The initial password is the last six digits of the mobile phone number',
  accountFormEmailTips:'You need to verify your email address when you log in for the first time. Please make sure that you enter my email address. After the verification takes effect, your account email address cannot be modified. ',
  isSetCommissionEmailTips: 'The contact is the only commission contact email. Assign a new contact email before canceling.',
}
